import React from "react";
import { Reveal } from "./fx/Reveal";

export const SectionHeading = ({ label, title, desc, align = "left", light = false }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {label && (
      <Reveal variant="fade">
        <div className={`mb-4 inline-flex items-center gap-2 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-8 bg-glow-2/70" />
          <span className="mono-label">{label}</span>
        </div>
      </Reveal>
    )}
    <Reveal>
      <h2 className={`font-display text-3xl font-extrabold leading-tight sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-white"}`}>
        {title}
      </h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.1}>
        <p className="mt-5 text-base leading-relaxed text-white/60">{desc}</p>
      </Reveal>
    )}
  </div>
);
